























































































import {Component, Vue, Provide} from 'vue-property-decorator';
import {Action, State} from 'vuex-class';
import ComplaintState from '@/store/modules/complaint/types';
import SingleComplaint from '@/views/Manager/Complaints/SingleComplaint.vue';
import HomeFooter from '@/components/common/home/HomeFooter.vue';
import HomeHeader from '@/components/common/home/HomeHeader.vue';
import Router from '@/router';

@Component({
    components: { SingleComplaint, HomeFooter, HomeHeader },
})
export default class Complaints extends Vue {

    @Action public getArchiveComplaints: any;
    @Action public setSingleComplaint: any;
    @Action public updateComplaint: any;

    @State('complaint') public complaintState: ComplaintState;

    public async created() {
        await this.getArchiveComplaints();
    }

    /**
     * Копировать заявление
     * @param complaint
     */
    public copyComplaint(complaint: any) {
        this.setSingleComplaint({
            id: 0,
            status: 'draft',
            articles: [],
            attachments: [],
            account_number: complaint.account_number,
            invoice_number: complaint.invoice_number,
            description: complaint.description,
            region: complaint.region,
            district: complaint.district,
            city: complaint.city,
            street: complaint.street,
            house: complaint.house,
            structure: complaint.structure,
            building: complaint.building,
            installation_date: complaint.installation_date,
            bad_date: complaint.bad_date,
            conditions: complaint.conditions,
            wishes: complaint.wishes,
        });
        //this.updateComplaint();
    }

    /**
     * Формируем строку с адресом
     * @param complaint
     */
    public getFullAddress(complaint) {
        const address = [
            complaint.region,
            complaint.district,
            complaint.city,
            complaint.street,
            complaint.house,
            complaint.structure,
            complaint.building,
        ];
        return address.filter((item) => (item && item !== '')).join(', ');
    }

}
